import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TouristGuideRate } from '../_models/tourist-guides-rates.model';
import { TouristGuidesRatesApiService } from '../_api/tourist-guides-rates.api.service';
import { catchError, finalize, throwError } from 'rxjs';
import { PricePipe } from '@/common/pipes/price.pipe';
import { FormatDateTimePipe } from '@/common/pipes/format-date-time.pipe';

interface DialogData {
	rate: TouristGuideRate;
	touristGuideId: number;
}

@Component({
	selector: 'app-tourist-guides-rate-delete-dialog',
	standalone: true,
	imports: [CommonModule, MatDialogModule, MatButtonModule, MatProgressSpinnerModule, PricePipe, FormatDateTimePipe],
	templateUrl: './tourist-guides-rate-delete-dialog.component.html',
	styleUrl: './tourist-guides-rate-delete-dialog.component.scss',
})
export class TouristGuidesRateDeleteDialogComponent {
	dialogRef = inject(MatDialogRef<TouristGuidesRateDeleteDialogComponent>);
	data = inject<DialogData>(MAT_DIALOG_DATA);
	isDeleting = signal(false);
	error = signal<string | null>(null);

	private readonly apiService = inject(TouristGuidesRatesApiService);

	onCancel(): void {
		this.dialogRef.close(false);
	}

	onConfirm(): void {
		if (this.isDeleting()) {
			return;
		}

		this.isDeleting.set(true);
		this.error.set(null);

		this.apiService
			.deleteRate(this.data.touristGuideId, this.data.rate.id)
			.pipe(
				catchError((err) => {
					this.error.set('Nie udało się usunąć stawki');
					return throwError(() => err);
				}),
				finalize(() => this.isDeleting.set(false)),
			)
			.subscribe(() => {
				this.dialogRef.close(true);
			});
	}
}
